module.exports = __webpack_public_path__ + "img/heart_outlines.3d3b36dd.svg";